import Pelias from './pelias';

const Providers = {
  Pelias,
};
export default Providers;
